import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { animateScroll } from 'react-scroll';
import Section from 'components/Section';
import TextField from 'components/TextField';
import NavigationButtons from 'components/NavigationButtons';
import PaymentInformationForm from 'components/PaymentInformation';
import i18n from 'utils/translate';
import { noNumbers, numberTwelveDigits } from 'utils/validators';
import { toast } from 'react-toastify';
import ErrorMessage from 'components/ErrorMessage';
import { linkTypeShape } from 'utils/types';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  backLink: PropTypes.shape(linkTypeShape).isRequired,
  nextLink: PropTypes.shape(linkTypeShape).isRequired
};

const defaultProps = {
  onChange: console.log,
  data: {}
};

class PersonalData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props.data,
      submitted: false,
      validForm: false
    };
  }

  handleSubmit = () => {
    const {
      nextLink: { go } = {
        go: () => {}
      },
      onChange
    } = this.props;
    const form = this.refs.form;
    const premiumRef = this.refs.premium;

    if (premiumRef.autonumeric.getNumber() <= 0) {
      this.setState({
        validForm: false
      });
      return;
    }

    if (form.checkValidity && !form.checkValidity()) {
      form.reportValidity();
      return;
    }

    this.setState(
      {
        premium: premiumRef.autonumeric.getNumber()
      },
      () => {
        onChange(this.state);

        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'onlinepayment',
            formname: 'OnlineFormMacedonia',
            action: 'Ihre Daten'
          });
        }

        go();
      }
    );
  };

  handleDataChange = (data, key) => {
    const { submitted } = this.state;

    this.setState(
      {
        [`${key}`]: data
      },
      () => {
        if (submitted) {
          this.setState({
            validForm: this.refs.form.checkValidity()
          });
        }
      }
    );
  };

  handlePaymentInfoChange = data => {
    const { submitted } = this.state;
    this.setState({ ...data }, () => {
      if (submitted) {
        this.setState({
          validForm: this.refs.form.checkValidity()
        });
      }
    });
  };

  componentDidMount() {
    animateScroll.scrollToTop({ duration: 0 });
  }

  render() {
    const { firstname, lastname, email, birthdate, paymentReference, premium, submitted, validForm, ...data } =
      this.state;
    const { backLink } = this.props;

    return (
      <form
        className={`page-step-wrapper page-step-wrapper--narrow ${submitted ? 'submitted' : ''}`}
        ref="form"
        onSubmit={this.handleSubmit}
      >
        <Section header={i18n('Zahlungsdaten')}>
          <TextField
            label={i18n('Nachname')}
            name="last_name"
            className="col-xs-12 col-md-3"
            required
            value={lastname}
            onChange={data => this.handleDataChange(data, 'lastname')}
            ref="lastname"
            pattern={noNumbers}
            maxLength={31}
          />
          <TextField
            label={i18n('Vorname')}
            name="first_name"
            className="col-xs-12 col-md-3"
            required
            value={firstname}
            onChange={data => this.handleDataChange(data, 'firstname')}
            ref="name"
            pattern={noNumbers}
            maxLength={13}
          />
          <TextField
            label={i18n('Geburtsdatum')}
            name="birthdate"
            ref="birthdate"
            className="col-xs-12 col-md-4"
            date
            required
            minDate={moment().add(-100, 'year')}
            maxDate={moment().add(-18, 'year')}
            onWrongDate={wrongDate => this.setState({ wrongDate })}
            onChange={data => this.handleDataChange(data, 'birthdate')}
            value={birthdate}
          />
          <TextField
            label={i18n('E-Mail')}
            name="email"
            type="email"
            className="col-xs-12 col-md-6 clear-both"
            required
            value={email}
            onChange={data => this.handleDataChange(data, 'email')}
            ref="email"
            maxLength={80}
          />
          <TextField
            label={i18n('Zahlungsreferenz laut Zahlschein')}
            name="paymentReference"
            className="col-xs-12 col-md-6 clear-both"
            required
            value={paymentReference}
            onChange={data => this.handleDataChange(data, 'paymentReference')}
            ref="payment_reference"
            pattern={numberTwelveDigits}
            maxLength={12}
          />
          <TextField
            label={i18n('Prämie laut Zahlschein')}
            name="premium"
            currencyInput
            className="col-xs-12 col-md-3 clear-both"
            required
            placeholder="0,00"
            value={premium}
            onChange={data => this.handleDataChange(data, 'premium')}
            ref="premium"
          />
        </Section>
        <PaymentInformationForm
          paymentInfo={{
            type: data.type ? data.type : 'hobex',
            iban: data.iban,
            bic: data.bic,
            showSepa: false
          }}
          onPaymentInfoChange={data => {
            this.handlePaymentInfoChange(data);
          }}
        />
        <NavigationButtons
          backLink={backLink}
          nextLink={{
            go: e => {
              this.setState({
                submitted: true,
                validForm: this.refs.form.checkValidity && this.refs.form.checkValidity()
              });

              Object.keys(this.refs).forEach(key => {
                if (this.refs[key].onBlur) {
                  this.refs[key].onBlur();
                }
              });

              if (this.refs.form.checkValidity && this.refs.form.checkValidity()) {
                toast.dismiss();
                this.handleSubmit();
              } else {
                toast.error(<ErrorMessage message={i18n('Bitte überprüfen Sie Ihre Angaben')} />);
              }
            }
          }}
        />
      </form>
    );
  }
}

PersonalData.defaultProps = defaultProps;
PersonalData.propTypes = propTypes;

export default PersonalData;
